import { HexColorPicker } from 'react-colorful';
import { useRef, useState, useEffect } from 'react';

const presetColors = [
  // Reds & Pinks
  '#f44336', // red
  '#e91e63', // pink
  '#f333ff', // magenta

  // Oranges & Yellows
  '#ff9800', // orange
  '#dac400', // yellow

  // Greens
  '#4caf50', // green
  '#8bc34a', // light green
  '#4bb189', // teal-green

  // Blues & Cyans
  '#00bcd4', // cyan
  '#2196f3', // blue

  // Purples
  '#9c27b0', // purple

  // Browns
  '#795548', // brown

  // Greys & Black
  '#787878', // grey
  '#000000', // black
];

const isValidHex = (hex: string) =>
  /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(hex);

const CustomColorPicker = ({ formik }: any) => {
  const [showPicker, setShowPicker] = useState(false);
  const [hexInput, setHexInput] = useState(formik.values.color || '#4bb189');
  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHexInput(formik.values.color || '#4bb189');
  }, [formik.values.color]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleHexInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setHexInput(value);
    if (isValidHex(value)) {
      formik.setFieldValue('color', value);
    }
  };

  return (
    <div
      ref={pickerRef}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      {/* Trigger */}
      <div className="d-flex align-items-center">
        <button
          id="color_btn"
          type="button"
          style={{
            backgroundColor: formik.values.color || '#4bb189',
            width: '1.5rem',
            height: '1.5rem',
            border: '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
          onClick={() => setShowPicker(!showPicker)}
        />
        <div className="px-2 d-flex align-items-center">
          <span
            className="badge tag-soft-badge"
            style={
              {
                fontSize: '0.75rem',
                whiteSpace: 'normal',
                '--color': formik.values.color || '#4bb189',
              } as React.CSSProperties
            }
          >
            {formik.values.name || 'Tag'}
          </span>
        </div>
      </div>

      {/* Color Picker */}
      {showPicker && (
        <div
          style={{
            position: 'absolute',
            zIndex: 20,
            background: '#fff',
            border: '1px solid #ccc',
            padding: '12px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            minWidth: '200px',
          }}
        >
          <HexColorPicker
            color={formik.values.color || '#4bb189'}
            onChange={(color) => {
              formik.setFieldValue('color', color);
              setHexInput(color);
            }}
          />

          {/* Hex input */}
          <input
            type="text"
            value={hexInput}
            onChange={handleHexInputChange}
            placeholder="#000000"
            maxLength={7}
            className="form-control mt-2"
          />

          {/* Presets */}
          <div className="mt-2 d-flex flex-wrap" style={{ gap: '6px' }}>
            {presetColors.map((preset) => (
              <div
                key={preset}
                onClick={() => {
                  formik.setFieldValue('color', preset);
                  setHexInput(preset);
                }}
                style={{
                  backgroundColor: preset,
                  width: '1.25rem',
                  height: '1.25rem',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomColorPicker;
